import { Type } from 'class-transformer';
import { CiramailAssignToUserResultDto } from '../../ciramail-module/_models/cira-mail/cira-mail-assign-to-user-result-dto';

export class CiramailAssignToTeamResultDto {
    teamName: string;

    @Type(() => CiramailAssignToUserResultDto)
    users: Array<CiramailAssignToUserResultDto>;
}
